import React from 'react';

import openFeedbackModal from '../leads/openFeedbackModal';

export const updateSearchCallback = async ({
  success,
  isMobile,
  closeModal,
  openModalAction,
  closeModalAction,
  createFeedbackModal,
  createNewSaveSearchFeedbackModal,
  modalTitle,
  poiNamesList,
  mycasaDomain,
}) => {
  await closeModalAction({ close: closeModal });

  if (!success) {
    setTimeout(() => {
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile,
        fail: true,
        failMethod: null,
        feedback: (
          <>
            <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
              Ci scusiamo per il disagio!
            </p>
            <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
              Al momento non è possibile modificare la ricerca.
            </p>
          </>
        ),
        title: modalTitle,
      });
    }, 451);
  } else {
    setTimeout(() => openFeedbackModal({
      isMobile,
      openModalAction,
      createFeedbackModal: createNewSaveSearchFeedbackModal,
      isFromUpdate: true,
      poiNamesList,
      mycasaDomain,
    }), 451);
  }
};

export const deleteSearchCallback = async ({
  success,
  isMobile,
  closeModal,
  openModalAction,
  closeModalAction,
  createFeedbackModal,
  modalTitle,
}) => {
  await closeModalAction({ close: closeModal });

  if (!success) {
    setTimeout(() => {
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile,
        fail: true,
        failMethod: null,
        feedback: (
          <>
            <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
              Ci scusiamo per il disagio!
            </p>
            <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
              Al momento non è possibile cancellare la ricerca.
            </p>
          </>
        ),
        title: modalTitle,
      });
    }, 451);
  }
};

export const saveSearchCallback = async ({
  success,
  isMobile,
  closeModal,
  openModalAction,
  closeModalAction,
  createNewSaveSearchFeedbackModal,
  createFeedbackModal,
  getSearchesList,
  modalTitle,
  disableProposeBkm,
  poiNamesList,
  mycasaDomain,
  isFromLogin,
}) => {
  await closeModalAction({ close: closeModal });
  setTimeout(() => {
    if (success) {
      disableProposeBkm && disableProposeBkm();
      openFeedbackModal({
        isMobile,
        openModalAction,
        createFeedbackModal: createNewSaveSearchFeedbackModal,
        isFromUpdate: false,
        poiNamesList,
        mycasaDomain,
        isFromLogin,
        getSearchesList,
      });
    } else {
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile,
        fail: true,
        failMethod: null,
        feedback: (
          <>
            <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
              Ci scusiamo per il disagio!
            </p>
            <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
              Al momento non è possibile salvare la ricerca.
            </p>
          </>
        ),
        title: modalTitle,
      });
    }
  }, 451);
};

export default ({
  openModalAction,
  closeModalAction,
  createNewSaveSearchModal,
  createGenericAfterSpecificModal,
  createNewSaveSearchFeedbackModal,
  createConsentRequestModal,
  createConsentMandatoryModal,
  createFeedbackModal,
  getSearchesList,
  isMobile,
  isSmallMobile,
  filtersProps,
  saveSearchProps,
  panelChooseBy,
  copyModalTitle,

}) => openModalAction(createNewSaveSearchModal({
  isMobile,
  isSmallMobile,
  filtersProps,
  copyModalTitle,
  saveSearchProps: {
    ...saveSearchProps,
    saveSearchCallback,
    updateSearchCallback,
    deleteSearchCallback,
    callbackPayload: {
      openModalAction,
      closeModalAction,
      createGenericAfterSpecificModal,
      createNewSaveSearchFeedbackModal,
      createFeedbackModal,
      getSearchesList,
      createConsentRequestModal,
      createConsentMandatoryModal,
    },
  },
  panelChooseBy,
}));
